document.addEventListener('click', (event) => {
  const step = event.target.closest('[data-qty-step]');
  if (!step) return;
  const input = step.closest('.qty').querySelector('input');
  const min = Number(input.min || 0);
  input.value = Math.max(min, Number(input.value || 0) + Number(step.dataset.qtyStep));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-cart-qty]')) event.target.form.requestSubmit();
});

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!form.matches('[data-quick-add]')) return;
  event.preventDefault();
  const button = form.querySelector('button');
  button.disabled = true;
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });
    if (!response.ok) throw new Error(response.statusText);
    const cart = await (await fetch(`${window.Shopify.routes.root}cart.js`)).json();
    document.querySelectorAll('[data-cart-count]').forEach((bubble) => {
      bubble.textContent = cart.item_count;
      bubble.hidden = cart.item_count === 0;
    });
  } catch {
    form.submit();
  } finally {
    button.disabled = false;
  }
});

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-menu-open]');
  if (opener) document.getElementById(opener.dataset.menuOpen)?.showModal();
  const dialog = event.target.closest('dialog');
  if (dialog && (event.target === dialog || event.target.closest('[data-menu-close]'))) dialog.close();
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!form.matches('[data-discount-form]')) return;
  event.preventDefault();
  const root = window.Shopify.routes.root;
  window.location = `${root}discount/${encodeURIComponent(form.code.value.trim())}?redirect=${root}cart`;
});

document.addEventListener('change', (event) => {
  if (!event.target.matches('.main-product__variant select')) return;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', event.target.value);
  window.location.replace(url);
});

const POSTCODE_KEY = 'florist:postcode';
const postcodeStore = {
  get() { try { return localStorage.getItem(POSTCODE_KEY); } catch { return null; } },
  set(value) { try { localStorage.setItem(POSTCODE_KEY, value); } catch {} },
};

const rememberPostcode = () => {
  const value = document.getElementById('zapiet-delivery-info__input__text')?.value.trim();
  if (value) postcodeStore.set(value);
};
document.addEventListener('click', (event) => {
  if (event.target.closest('#zapiet-delivery-info__input__button')) rememberPostcode();
}, true);
document.addEventListener('keydown', (event) => {
  if (event.key === 'Enter' && event.target.id === 'zapiet-delivery-info__input__text') rememberPostcode();
}, true);

// ponytail: the Zapiet widget has no ready event, so poll briefly for its input and public check method.
window.addEventListener('load', () => {
  const summary = document.querySelector('[data-default-postcode]');
  if (!summary) return;
  const postcode = postcodeStore.get() || summary.dataset.defaultPostcode;
  if (!postcode) return;
  let tries = 0;
  const timer = setInterval(() => {
    const input = document.getElementById('zapiet-delivery-info__input__text');
    const widget = window.ZapietProductDeliveryInfo;
    if (++tries > 50) return clearInterval(timer);
    if (!input || !widget?.checkDeliveryEligibility) return;
    clearInterval(timer);
    if (input.value || input.closest('#zapiet-delivery-info__input')?.style.display === 'none') return;
    input.value = postcode;
    document.addEventListener('focusin', (event) => {
      if (event.target.id === 'zapiet-delivery-info__content') event.target.blur();
    }, { once: true });
    widget.checkDeliveryEligibility();
  }, 100);
});

document.addEventListener('click', (event) => {
  const dialog = document.getElementById('DeliveryCheck');
  const open = event.target.closest('[data-open-delivery-check]');
  if (!dialog || !(open || event.target.closest('[data-delivery-retry]'))) return;
  dialog.querySelectorAll('[data-delivery-panel]').forEach((panel) => (panel.hidden = true));
  dialog.querySelector('[data-delivery-check]').hidden = false;
  if (open) dialog.showModal();
  else dialog.querySelector('[name="postcode"]').select();
});

document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-delivery-check]');
  if (!form) return;
  event.preventDefault();
  const validator = window.ZapietDeliveryValidator;
  if (!validator) return;
  const submit = form.querySelector('[type="submit"]');
  const postcode = form.postcode.value.trim().toUpperCase();
  const showPanel = (state) => {
    const panel = form.parentElement.querySelector(`[data-delivery-panel="${state}"]`);
    panel.querySelector('[data-delivery-postcode]').textContent = postcode;
    submit.disabled = false;
    form.hidden = true;
    panel.hidden = false;
  };
  const showError = () => {
    const result = form.querySelector('[data-delivery-result]');
    const heading = document.createElement('strong');
    heading.textContent = validator.getTranslation('error_heading');
    result.replaceChildren(heading, document.createElement('br'), validator.getTranslation('error_content'));
    submit.disabled = false;
  };
  submit.disabled = true;
  validator.checkEligibility(encodeURIComponent(postcode), () => showPanel('eligible'), () => showPanel('not_eligible'), showError);
});

// ponytail: the Zapiet notes field has a label but no placeholder; copy the label in so it can sit inside the field.
const notePlaceholders = () => {
  document.querySelectorAll('[class*="-Note__input"]:not([placeholder])').forEach((input) => {
    const label = input.parentElement.querySelector('[class*="-Note__label"]');
    if (label) input.placeholder = label.textContent.trim();
  });
};
if (document.body.classList.contains('template-cart')) {
  notePlaceholders();
  new MutationObserver(notePlaceholders).observe(document.body, { childList: true, subtree: true });
}
